import ApiResponse from "@/models/ApiResponse";
import http, { handleApiResponse } from "@/services/http";
import { formatDateISO } from "@/utils/formatDates";
import { Accrual, AccrualAmount, AccrualBase } from "../models/Accrual";

export default class AccrualApi {
  static get(prefix: string, invoiceID: number): Promise<Accrual> {
    return http
      .get<ApiResponse<Accrual>>(`accrual/${prefix}/${invoiceID}`)
      .then(handleApiResponse)
      .then(AccrualApi.toModel);
  }

  // Elhatárolható összegek ÁFA-levonhatóság szerint (számla szintű + tételenkénti)
  static getBase(prefix: string, invoiceID: number): Promise<AccrualBase> {
    return http
      .get<ApiResponse<AccrualBase>>(`accrual/${prefix}/${invoiceID}/base`)
      .then(handleApiResponse)
      .then((result) => new AccrualBase({ ...result, items: result?.items ?? [] }));
  }

  static manage(prefix: string, accrual: Accrual, deleteAccounting = false): Promise<Accrual> {
    return http
      .put<ApiResponse<Accrual>>(`accrual/${prefix}`, { accrual, deleteAccounting })
      .then(handleApiResponse)
      .then(AccrualApi.toModel);
  }

  // Tétel szintű elhatárolások (számlatételenként egy fej sor, inv_item = tétel ID)
  static getItems(prefix: string, invoiceID: number): Promise<Accrual[]> {
    return http
      .get<ApiResponse<Accrual[]>>(`accrual/${prefix}/${invoiceID}/items`)
      .then(handleApiResponse)
      .then((result) => result?.map(AccrualApi.toModel) ?? []);
  }

  static manageItems(prefix: string, invoiceID: number, accruals: Accrual[]): Promise<Accrual[]> {
    return http
      .put<ApiResponse<Accrual[]>>(`accrual/${prefix}/items`, { invNo: invoiceID, accruals })
      .then(handleApiResponse)
      .then((result) => result?.map(AccrualApi.toModel) ?? []);
  }

  static toModel(result: Accrual): Accrual {
    return new Accrual({
      ...result,
      startDate: formatDateISO(result.startDate),
      endDate: formatDateISO(result.endDate),
      items:
        result.items?.map(
          (i) =>
            new AccrualAmount({
              ...i,
              accDate: formatDateISO(i.accDate),
            })
        ) ?? [],
    });
  }
}
